import { registerOnce } from '@shared/modules/WebWidgets/Registration'
import WebWidgets from './WebWidgets'
import { WIDGET_SELECTOR } from '@shared/config/constants'

import { APP } from '@shared/config/constants'

window._appName = APP.DVP.name
window._appGroup = APP.DVP.group

registerOnce(WebWidgets, WIDGET_SELECTOR.SETUP)
